import React from "react";
import ModalPrograms from "./ModalPrograms";
import Img from "./basic/Img";

function Modal({ data, ...props }) {
    const closeModal = () => {
        document
            .getElementById("modal-wrap")
            .style.setProperty("display", "none");
        document
            .getElementById("modal-main")
            .style.setProperty("overflow-y", "scroll");
        document.body.style.overflowY = "scroll";
        document
            .getElementById("modal-main")
            .classList.remove("modal-timetable");
    };
    return (
        <div className="modal-wrap" id="modal-wrap">
            <div className="modal-bg">
                <div
                    onClick={() => closeModal()}
                    className="modal-main-bg"
                    id="modal-main-bg"
                ></div>
            </div>
            <div className="modal-main" id="modal-main">
                <div id="timetable">
                    <a onClick={() => closeModal()}>
                        <Img
                            fileName="timeTableClose"
                            className="timetable-close"
                        />
                    </a>
                    <div className="timetable" id="timetable-do-not-stretch">
                        <Img fileName="timeline" className="timetableImg" />
                    </div>
                </div>
                <ModalPrograms programData={data} />
            </div>
        </div>
    );
}

export default Modal;
